// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TvWorkspaceManagerState;
(function (TvWorkspaceManagerState) {
    TvWorkspaceManagerState[TvWorkspaceManagerState["Unknown"] = 0] = "Unknown";
    TvWorkspaceManagerState[TvWorkspaceManagerState["Loading"] = 1] = "Loading";
    TvWorkspaceManagerState[TvWorkspaceManagerState["Loaded"] = 2] = "Loaded";
})(TvWorkspaceManagerState || (TvWorkspaceManagerState = {}));
